import * as React from "react";
import { NavLink } from "react-router-dom";
import { CircularProgress, withStyles, Tooltip } from "@material-ui/core";

import { CompositionStore } from "modules/composition/CompositionStore";
import { Task as TaskIcon } from "common/icons";
import classNames from "classnames";

const styles = (theme) => ({
  level: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#212121",
    stroke: "#212121",
    fontWeight: 400,
    alignItems: "center",
    minHeight: "34px",
    paddingTop: "6px",
    paddingBottom: "6px",
    display: "flex",
    textDecoration: "none",
  },
  activeLink: {
    backgroundColor: "#697513",
    color: "#fff",
    stroke: "#fff",
  },
  folder: {
    fontSize: "18px",
  },
  textC: {
    display: "block",
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
    textOverflow: "ellipsis !important",
  },
});

type IProps = {
  classes: any;
  id: string;
  path: Array<string>;
  index: any;
};

class Task extends React.Component<IProps> {
  state = {
    name: false,
    tasks: [] as any,
  };

  componentDidMount() {
    this.getRateTask();
  }
  async componentWillReceiveProps(nextProps) {
    const { index, path, id } = nextProps;
    if (
      this.props.path.join("/") !== path.join("/") &&
      index + 1 === path.length
    ) {
      let task = CompositionStore.tasks.find((item) => item.id === id),
        tasks = new Array();
      if (task) tasks = task.data.compositionList;
      CompositionStore.group = false;
      CompositionStore.rateTask = task;

      await CompositionStore.getRateTasks(tasks, true);
      this.setState({ loaded: true });
    }
  }
  getRateTask = async () => {
    const { id, path, index } = this.props;
    let task = await CompositionStore.getRateTask(id);
    if (task) {
      let tasks = task.data.compositionList;
      if (index + 1 === path.length) {
        CompositionStore.group = false;
        CompositionStore.rateTask = task;
        await CompositionStore.getRateTasks(tasks, true);
        this.setState({ loaded: true });
      }
      this.setState({ name: task.data.description, tasks });
    }
  };

  renderChildTask = () => {
    const { path, index, classes } = this.props;
    if (path[index + 1]) {
      let splitted = path[index + 1].split("~");
      if (splitted[0] === "task" && this.state.tasks.includes(splitted[1]))
        return (
          <Task
            id={splitted[1]}
            path={path}
            index={index + 1}
            classes={classes}
          />
        );
    }
    return null;
  };
  render() {
    const { classes, id, path, index } = this.props,
      { name } = this.state;
    let pth =
        path.length === 0
          ? [CompositionStore.benchComposition.id]
          : [CompositionStore.benchComposition.id, ...path].slice(0, index + 1),
      stringPath = pth.join("/"),
      paddingLeft = `${25 * (index + 1)}px`;
    return name ? (
      <React.Fragment>
        <NavLink
          exact={true}
          className={classes.level}
          style={{ paddingLeft }}
          activeClassName={classes.activeLink}
          to={`/menu/rateLibraries/${stringPath}/task~${id}`}
        >
          <span style={{ marginRight: "10px" }}>
            <TaskIcon className={classes.folder} />
          </span>
          <Tooltip title={name}>
            <div className={classNames(classes.textC, "sideName")}>{name}</div>
          </Tooltip>
        </NavLink>
        {this.renderChildTask()}
      </React.Fragment>
    ) : (
      <span className={classes.level} style={{ paddingLeft }}>
        <CircularProgress size={15} />
      </span>
    );
  }
}

export default withStyles(styles)(Task);



// WEBPACK FOOTER //
// ./src/modules/composition/components/layouts/Task.tsx